// extracted by mini-css-extract-plugin
export default {"card":"NoteCard-module__card__rWzHE","icon":"NoteCard-module__icon__nNG47","title":"NoteCard-module__title__0pj0w","text":"NoteCard-module__text__e6zvQ"};